import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { bulkUpdateTimezone } from "../api/users";

export const useBulkUpdateTimezone = (onSuccess) => {
  const queryClient = useQueryClient();

  const bulkUpdateTimezoneMutation = useMutation({
    mutationFn: async ({ userSqids, timezone }) => {
      return bulkUpdateTimezone(userSqids, timezone);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });
      queryClient.invalidateQueries({
        queryKey: ["team-members-search"],
      });
      toast.success(
        `${variables.userSqids.length} user timezone${
          variables.userSqids.length === 1 ? "" : "s"
        } updated`,
      );
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(
        Object.values(error?.response?.data?.errors ?? {})[0]?.[0] ??
          "There was problem updating timezones. Please try again.",
      );
    },
  });

  return { bulkUpdateTimezoneMutation };
};
